import { styled } from '@mui/material/styles';
import {
  Container,
  Box, 
  Button, 
  Card, 
  CardContent, 
  Checkbox, 
  CircularProgress, 
  Grid, 
  IconButton, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Typography,
} from '@mui/material';
export const CustomTable = styled(Table)(() => ({
  '& .MuiTableRow-root:hover': {
    backgroundColor: 'transparent',
  },
}));
export const CustomTableBody = styled(TableBody)(() => ({
  '& .MuiTableRow-root:hover': {
    backgroundColor: 'transparent',
  },
}));
export const CustomTableRow = styled(TableRow)(() => ({
  '& .MuiTableRow-root:hover': {
    backgroundColor: 'transparent',
  },
}));
export const CustomTableCell = styled(TableCell)(() => ({
  borderBottom: '1px solid #E6E8EB',
  padding: '0 !important',
}));
export const Content = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: 16,
  borderBottom: '1px solid #E6E8EB',
  [theme.breakpoints.down('sm')]: {
    padding: 8,
  },
}));
export const CustomIconButton = styled(IconButton)(() => ({
  borderRadius: '50%',
  transition: 'background 0.2s',
}));
export const ContentInner = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
}));
export const TableTitle = styled(Typography)(() => ({
  fontSize: '20px',
  fontWeight: 600,
}));
export const AveragePrice = styled(Typography)(() => ({
  fontSize: '20px',
  fontWeight: 600,
  color: 'green',
}));
export const Title = styled(Typography)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBlock: '20px',
  color: '#1A202C',
  fontSize: '24px',
  fontWeight: 600,
}));
export const CustomTableContainer = styled(TableContainer)(() => ({
  marginBottom: '20px',
}));
export const OptionsTitle = styled(Typography)(() => ({
  fontSize: '18px',
  borderTop: '1px solid #E6E8EB',
  fontWeight: 600,
  display: 'flex',
  justifyContent: 'start',
  paddingTop: '16px',
  marginTop: '16px',
  alignItems: 'center',
  marginBottom: '10px',
}));
export const GridContainer = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}));
export const GridItem = styled(Grid)(() => ({
  display: 'block',
}));
export const CustomCard = styled(Card)(() => ({
  boxShadow: 'none',
  display: 'flex',
  marginRight: 'auto',
}));
export const CustomCardContent = styled(CardContent)(() => ({
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
  '&:last-child': {
    paddingBottom: 0,
  },
}));
export const CustomCardContentInner = styled(Box)(() => ({
  display: 'flex',
  gap: 8,
}));
export const TotalText = styled(Typography)(() => ({
  fontSize: '20px',
  fontWeight: 500,
}));
export const TotalTextLineThrough = styled(Box)(() => ({
  textDecoration: 'line-through',
  fontSize: '20px',
  fontWeight: 500,
  lineHeight: 1.5,
  color: '#b31818',
}));
export const ButtonsContainer = styled(Container)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 8,
  marginTop: 16,
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: '#ffffff',
  padding: '16px 24px',
  zIndex: 10,
  borderTop: '1px solid #E6E8EB',
  boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.05)',
  [theme.breakpoints.down('sm')]: {
    padding: '12px 16px',
  },
  [theme.breakpoints.up('lg')]: {
    maxWidth: 'none',
    paddingRight: 0,
    paddingLeft: 0,
  },
}));
export const CustomButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: 'white',
  p: '0.75rem 2rem',
  fontSize: '1.1rem',
  textTransform: 'none',
  transition: 'all 0.2s ease',
  '&:hover': {
    bgcolor: '#4A6FE8',
    transform: 'translateY(-1px)',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },
  '&.Mui-disabled': {
    bgcolor: '#E2E8F0', 
    color: '#A0AEC0',
  },
}));
export const LoadingContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 1,
}));
export const CustomCircularProgress = styled(CircularProgress)(() => ({
  color: 'white',
}));
export const OptionContainer = styled(Box)<{ isLast?: boolean }>(({ theme, isLast }) => ({
  display: 'flex',
  flexDirection: 'column',
  borderBottom: isLast ? 'none' : '1px solid #E6E8EB',
  paddingLeft: 32,
  paddingRight: 16,
  paddingBottom: 16,
  [theme.breakpoints.down('md')]: {
    paddingLeft: 24,
  },
  [theme.breakpoints.down('sm')]: {
    paddingLeft: 16,
  },
}));
export const OptionContainerInner = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 16,
  paddingBlock: 8,
  borderRadius: 8,
  bgcolor: 'white',
}));
export const Description = styled(Typography)(() => ({
  textAlign: 'left',
  width: '100%',
  fontWeight: 500,
  fontSize: '16px',
}));
export const OptionActions = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 8,
}));
export const ChatButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: 'white',
  textTransform: 'none',
  minWidth: '120px',
  whiteSpace: 'nowrap',
  '&:hover': {
    backgroundColor: '#4A6FE8',
  },
  '&.Mui-disabled': {
    backgroundColor: '#E2E8F0',
    color: '#A0AEC0',
  },
}));
export const CustomCheckbox = styled(Checkbox)(({ theme }) => ({
  color: '#A0AEC0',
  display: 'inline-flex',
  alignItems: 'start',
  justifyContent: 'center',
  padding: 0,
  '&.Mui-checked': {
    color: theme.palette.primary.main,
  },
}));
export const CheckboxContainer = styled('span')(() => ({
  minWidth: '120px',
  textAlign: 'center',
}));
export const OptionsContainer = styled(Box)(() => ({
  marginTop: 8,
  width: '100%',
  border: '1px solid #E6E8EB',
  borderRadius: 8,
  bgcolor: 'white',
}));
export const OptionsContainerInner = styled(Box)(() => ({
  padding: '16px 24px',
}));
export const AlternativesTitle = styled(Typography)(({ theme }) => ({
  fontSize: '16px',
  fontWeight: 500,
  color: theme.palette.text.secondary,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '10px',
}));  
export const AlternativesTable = styled(Table)(( { theme }) => ({
  '& .MuiTableHead-root': {
    bgcolor: theme.palette.primary.main,
  },
  '& .MuiTableCell-root': {
    borderBottom: 'none',
  },
  '& .MuiTableHead-root .MuiTableCell-root': {
    color: 'white',
    fontSize: '16px',
    fontWeight: 600,
  },
}));
export const CustomTableHead = styled(TableHead)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
}));
export const CustomTableHeadText = styled(Typography)(() => ({
  color: 'white',
  fontSize: '20px',
  fontWeight: 600,
}));
export const CustomTableHeadCell = styled(TableCell)(() => ({
  borderBottom: 'none !important',
}));
export const FindingsContainer = styled(Box)(() => ({
  backgroundColor: '#F7FAFC',
  borderRadius: 8,
  padding: '12px 16px',
  marginTop: 8,
  marginBottom: 8,
  border: '1px solid #E2E8F0',
}));
export const FindingsTitle = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 600,
  color: theme.palette.primary.main,
  marginBottom: 4,
  display: 'flex',
  alignItems: 'center',
  gap: 6,
}));
export const FindingsText = styled(Typography)(() => ({
  fontSize: '14px',
  fontWeight: 400,
  color: '#4A5568',
  lineHeight: 1.5,
}));
